module.exports = __webpack_public_path__ + "static/img/backBook.a4d9a68.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backBook.jpg
// module id = O609
// module chunks = 4